var pca = {};

var APIKEY = 'JN67-PT76-RR57-ZZ65';
var apiMethod = function(method) {
  return 'https://services.postcodeanywhere.co.uk/CapturePlus/Interactive/' + method + '/v2.10/json3.ws';
};

pca.findAddress = function(searchTerm, lastId) {
  lastId = lastId ? lastId : '';
  return $.ajax({
    type: 'GET',
    contentType: 'application/json',
    url: apiMethod('Find'),
    data: {
      Key: APIKEY,
      Country: 'GBR',
      LastId: lastId,
      SearchTerm: searchTerm,
      FuzzyMatch: true
    }
  });
};
pca.lookupAddressById = function(id) {
  return $.ajax({
    type: 'GET',
    contentType: 'application/json',
    url: apiMethod('Retrieve'),
    data: {
      Key: APIKEY,
      Id: id
    }
  });
};

module.exports = pca;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/services/pca.js
// module id = 16
// module chunks = 0